import styled from "styled-components";
import { variant, size, position } from "styled-system";

import { Wrapper } from "../Grid";

const HeaderWrapper = styled(Wrapper)`
  z-index: 5000;
  width: 100%;
  transition: 400ms ease-in-out;
  ${size};
  ${position};
  ${variant({
    variants: {
      light: {
        backgroundColor: "white.100",
      },
      dark: {
        backgroundColor: "header.dark.bg",
      },
      grey: {
        backgroundColor: "header.grey.bg",
      },
    },
  })}
`;

HeaderWrapper.defaultProps = {
  as: "header",
  height: ["74px",null, "105px", "158px"],
};

export { HeaderWrapper };
